import {
    IListState,
    initialListState
} from '../shared/list/list.state';

export interface IUsersState {
    users: IListState;
    viewedUserId: string;
}

export function initialUsersState(): IUsersState {
    return {
        users: {
            ...initialListState
        },
        viewedUserId: null
    };
}
